/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

import { ONE_DAY_TS } from '@constants/time'

export const hourFormatConvert = (hr: number) => {
  if (`${hr}`.length < 2) {
    return `0${hr}`
  }

  return `${hr}`
}

export const getLaterDayTS = (from: number, days = 1) =>
  +new Date(from + ONE_DAY_TS * days)

export const getEarlierDayTS = (from: number, days = 1) =>
  +new Date(from - ONE_DAY_TS * days)

export const wait = (ms: number) =>
  new Promise(resolve => {
    setTimeout(resolve, ms)
  })

export const getTimeZoneOffset = (timeZone: string, date = new Date()) => {
  const tzString = date.toLocaleString('en-US', { timeZone })
  const localString = date.toLocaleString('en-US')
  const diff = (Date.parse(localString) - Date.parse(tzString)) / 3600000
  const offset = -(diff + date.getTimezoneOffset() / 60)
  const isPositive = offset >= 0

  return isPositive
    ? `+${hourFormatConvert(offset)}`
    : `-${hourFormatConvert(-offset)}`
}

const DEFAULT_LOCALE_TIME_DEPLAY_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
}

export const getFormattedLocaleTimeString = (
  date: Date,
  option: Intl.DateTimeFormatOptions = DEFAULT_LOCALE_TIME_DEPLAY_OPTIONS
) => date.toLocaleDateString('en', option)

export const getFSSTimeDisplayFormat = (date: Date, utcOffset: string) => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const d = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  return `${year}-${hourFormatConvert(month)}-${hourFormatConvert(
    d
  )} ${hourFormatConvert(hour)}:${hourFormatConvert(
    minute
  )}:${hourFormatConvert(second)} UTC${utcOffset}00`
}

export const formatDateISOString = (str: string) =>
  str?.replace(/\.\d+Z$/g, 'Z')

export const getTimeZoneDateInstance = (tz?: string) => (dateStr?: string) => {
  const date =
    new Date(dateStr).toString() !== 'Invalid Date'
      ? new Date(dateStr)
      : new Date()

  return tz
    ? new Date(
        date.toLocaleString('en-US', {
          timeZone: tz,
        })
      )
    : date
}

export const awaitTimeout = (ms: number) =>
  // eslint-disable-next-line no-promise-executor-return
  new Promise(resolve => setTimeout(resolve, ms))
